module Meevo.Plugins.ClientApp {

    const MAXSAFEINTEGER = 2147483647;

    export class ServiceMenuConfigSection extends Meevo.Components.CommonClasses.CommonSectionBase {

        public serviceCategories: any;
        public services: any;
        public basedataService: Meevo.Components.BaseClasses.IDataService;
        public customButtonsSet: any;
        public copy: any;
        public auditNoun: Meevo.Model.NounEnum;

        constructor(sectionId: number,
            displayNameContentKey: string,
            template: string,
            isPrimarySection: boolean,
            handlesOwnCrud: boolean,
            baseEndpoint: string,
            sectionEndpoint: string,
            loggingService: Meevo.Components.Logging.ILoggingService,
            commonDataService: Meevo.Components.CommonClasses.ICommonDataService,
            dataService: Meevo.Components.BaseClasses.IDataService,
            noun: Meevo.Model.NounEnum = null,
            identityService: Components.Common.IIdentityService = null,
            protected modalService: Meevo.Components.Modal.IModalService,
            protected $filter: angular.IFilterService,
            protected busyService: Meevo.Components.Busy.IBusyService,
            sectionSecurityKey?: string,
            protected context?: Meevo.Plugins.ClientApp.ClientAppContext) {

            super(sectionId, displayNameContentKey, template, isPrimarySection, handlesOwnCrud, baseEndpoint, sectionEndpoint, loggingService, commonDataService, noun, identityService, sectionSecurityKey + Meevo.Components.Common.SecurityParts.KEY_PART_READ);
            this.basedataService = dataService;
            this.initializeData();
        }

        initializeData(): void {
            this.auditNoun = Meevo.Model.NounEnum.ClientAppServiceMenu;
            this.getServiceCategories();
            this.context.setMode(Model.MaintenanceFormState.Readonly);
            this.mode = Model.MaintenanceFormState.Readonly;

            var scope = this;
            this.customButtonsSet = [
                {
                    text: 'LABEL_EDIT',
                    clickHandler: () => {
                        this.basedataService.trackUsage(Meevo.Model.NounEnum.ClientAppServiceMenuTab, Model.VerbEnum.EditButtonClicked, null, null);
                        scope.context.edit();
                        scope.takeBackup();
                    },
                    classNames: 'meevo-button',
                    disableRules: () => false,
                    visibilityRules: () => this.mode == Model.MaintenanceFormState.Readonly,
                    securityRules: Meevo.Components.Common.SecurityKeys.INTEGRATION_CLIENTAPP_TAB_SERVICEMENUCONFIG + Meevo.Components.Common.SecurityParts.KEY_PART_WRITE,
                    position: 'right'
                },
                {
                    text: 'LABEL_SAVE',
                    clickHandler: () => {
                        this.basedataService.trackUsage(Meevo.Model.NounEnum.ClientAppServiceMenuTab, Model.VerbEnum.SaveButtonClicked, null, null);
                        scope.saveServiceMenuConfig();
                    },
                    classNames: 'meevo-button',
                    disableRules: () => false,
                    visibilityRules: () => this.mode == Meevo.Model.MaintenanceFormState.Editing,
                    securityRules: Meevo.Components.Common.SecurityKeys.INTEGRATION_CLIENTAPP_TAB_SERVICEMENUCONFIG + Meevo.Components.Common.SecurityParts.KEY_PART_WRITE,
                    position: 'right'
                },
                {
                    text: 'LABEL_CANCEL',
                    clickHandler: () => {
                        this.basedataService.trackUsage(Meevo.Model.NounEnum.ClientAppServiceMenuTab, Model.VerbEnum.CancelButtonClicked, null, null);
                        this.serviceCategories = angular.copy(this.copy);
                        scope.context.setMode(Model.MaintenanceFormState.Readonly);
                        scope.mode = Model.MaintenanceFormState.Readonly;
                    },
                    classNames: 'meevo-button',
                    disableRules: () => false,
                    visibilityRules: () => this.mode == Meevo.Model.MaintenanceFormState.Editing,
                    securityRules: Meevo.Components.Common.SecurityKeys.INTEGRATION_CLIENTAPP_TAB_SERVICEMENUCONFIG + Meevo.Components.Common.SecurityParts.KEY_PART_WRITE,
                    position: 'right'
                },
            ];
        }

        activate(): any {
            super.activate();
        }

        getServiceCategories() {
            var criteria = {
                criteria: {
                    businessType: null,
                    coBusinessTypeId: null,
                    coFilterByLocationId: null,
                    coSearchResultFilter: 0,
                    coSearchType: 0,
                    includeActive: true,
                    includeDeleted: false,
                    includeInactive: false,
                    location: null,
                    maintenanceMode: true,
                },
                itemsPerPage: MAXSAFEINTEGER,
                pageNumber: 0,
                sortBy: null,
                sortDirection: 0
            };

            this.dataService.customMethodData("api/ClientApp/ServiceMenuConfig/List", "POST", criteria).then((data) => {
                if (data.data) {
                    this.serviceCategories = data.data;
                    this.updateServiceCategoriesInfo(null, this.serviceCategories);
                    this.copy = angular.copy(this.serviceCategories);
                }
            });

            //this.serviceCategories = new Meevo.Components.BaseClasses.PagedResults(this.basedataService, "ClientApp/ServiceMenuConfig", this.updateServiceCategoriesInfo, this);
            //this.serviceCategories.initSearch(criteria, null, criteria);
            //this.copy = angular.copy(this.serviceCategories.loadedPages);
        }

        updateServiceCategoriesInfo = (pageNumber, serviceCategories: any): void => {
            if (serviceCategories != null) {
                serviceCategories.forEach(category => {
                    for (var i = 0; i < category.services.length; i++) {
                        if (category.services[i] != null && (category.services[i].hasOverride || !isNaN(category.services[i].priceText))) {

                            let currencyFilter = this.$filter('meevoCurrency') as angular.IFilterCurrency;
                            let value = category.services[i].priceText.toString().replace('{currency}', '');
                            category.services[i].priceText = currencyFilter(value);
                        }

                        if (category.services[i] != null && category.services[i].isEnabled) {
                            category.isEnabled = true;
                        }
                    }
                });
            }
        };

        public saveServiceMenuConfig(): void {
            this.busyService.start();
            var serviceCategories = { serviceCategories: [] };

            for (var i = 0; i < this.serviceCategories.length; i++) {
                var changedCategory = angular.copy(this.serviceCategories[i]);
                changedCategory.services = [];
                for (var k = 0; k < this.serviceCategories[i].services.length; k++) {
                    var service = angular.copy(this.serviceCategories[i].services[k]);

                    if (service.isEnabledReverted) {
                        service.isEnabled = null;
                    }

                    if (service.isPriceReverted) {
                        service.priceText = null;
                    }

                    if (service.wasChanged) {// && this.wasServiceChanged(service))
                        changedCategory.services.push(service);
                    }
                }

                if (changedCategory.services.length >= 1) {
                    serviceCategories.serviceCategories.push(changedCategory);
                }
            }

            this.dataService.customMethodData("api/ClientApp/ServiceMenuConfig", "POST", serviceCategories).then((data) => {
                this.getServiceCategories();
            }).finally(() => {
                this.mode = Model.MaintenanceFormState.Readonly;
                this.busyService.stop();
            });
        }

        public clickCategory(category): void {
            if (this.mode == Model.MaintenanceFormState.Readonly)
                return;

            if (category.isEnabled) {
                for (var i = 0; i < category.services.length; i++) {
                    category.services[i].isEnabled = true;
                    category.services[i].wasChanged = true;
                }
            }
            else {
                for (var i = 0; i < category.services.length; i++) {
                    category.services[i].isEnabled = false;
                    category.services[i].wasChanged = true;
                }
            }
        }
        
        public clickService(category, serviceIsEnabled): void {
            if (this.mode == Model.MaintenanceFormState.Readonly)
                return;

            if (serviceIsEnabled) {
                category.isEnabled = true;
                return;
            }
            else if (!serviceIsEnabled) {
                for (var i = 0; i < category.services.length; i++) {
                    if (category.services[i].isEnabled) {
                        return;
                    }
                }
                category.isEnabled = false;
            }
        }

        public showRevertEnabledIndicator(service): boolean {
            var showIndicator = false;

            if (service.isEnabled != service.isEnabled_T && !this.context.isApplicationModeCO())
                showIndicator = true;

            return showIndicator;
        }
        
        public revertToParentEnabled(service, category): void {
            if (this.mode == Model.MaintenanceFormState.Readonly)
                return;

            service.isEnabled = service.isEnabled_T;
            service.isEnabledReverted = true;
            service.wasChanged = true;

            if (service.isEnabled) {
                category.isEnabled = true;
            }
            else {
                var allServicesDisabled = true;
                for (var i = 0; i < category.services.length; i++) {
                    if (!category.services[i].isEnabled) {
                        allServicesDisabled = false;
                        break;
                    }
                }
                if (allServicesDisabled)
                    category.isEnabled = false;
            }
        }

        public showRevertPriceIndicator(service): boolean {
            var showIndicator = false;

            if (this.context.isApplicationModeCO())
                return showIndicator;

            if (service.priceText_L == null && isNaN(service.priceText) && !isNaN(service.priceText_T)) {
                let currencyFilter = this.$filter('meevoCurrency') as angular.IFilterCurrency;
                let value = service.priceText_T.toString().replace('{currency}', '');
                if (service.priceText != currencyFilter(value) ) {
                    showIndicator = true;
                }
            }
            else if (service.priceText_L == null && service.priceText != service.priceText_T )
                showIndicator = true;
            else if (service.priceText_L != null && isNaN(service.priceText) && !isNaN(service.priceText_L)) {
                let currencyFilter = this.$filter('meevoCurrency') as angular.IFilterCurrency;
                let value = service.priceText_L.toString().replace('{currency}', '');
                if (service.priceText != currencyFilter(value)) {
                    showIndicator = true;
                }
            }
            else if (service.priceText_L != null && service.priceText != service.priceText_L)
                showIndicator = true;

            return showIndicator;
        }

        public revertToParentPrice(service): void {
            if (this.mode == Model.MaintenanceFormState.Readonly)
                return;

            if (service.priceText_L != null && !isNaN(service.priceText_L)) {
                let currencyFilter = this.$filter('meevoCurrency') as angular.IFilterCurrency;
                let value = service.priceText_L.toString().replace('{currency}', '');
                service.priceText = currencyFilter(value);
            }
            else if (service.priceText_L != null) {
                service.priceText = service.priceText_L;
            }
            else if (!isNaN(service.priceText_T)) {
                let currencyFilter = this.$filter('meevoCurrency') as angular.IFilterCurrency;
                let value = service.priceText_T.toString().replace('{currency}', '');
                service.priceText = currencyFilter(value);
            }
            else
                service.priceText = service.priceText_T;

            service.isPriceReverted = true;
            service.wasChanged = true;
        }

        changeService(service): void {
            service.wasChanged = true;
        }
    }
}